import Swiper from 'swiper/bundle';

const Testimonials = () => {
  const sliders = document.querySelectorAll('.testimonials__swiper');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (!(slider instanceof Element)) return;

    const swiperWrapper = slider.querySelector('.testimonials__swiper-wrapper');
    if (!swiperWrapper) return;

    // 👇 Equalize the content (not the whole slide)
    const rows = slider.querySelectorAll('.testimonials__row');
    let maxHeight = 0;
    rows.forEach(row => {
      const height = row.scrollHeight;
      if (height > maxHeight) maxHeight = height;
    });
    rows.forEach(row => {
      row.style.minHeight = `${maxHeight}px`;
    });

    const parent = slider.closest('.testimonials');

    new Swiper(slider, {
      slidesPerView: 1,
      effect: "fade",
        fadeEffect: {
        crossFade: true
      },
      autoHeight: false,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: parent.querySelector('.testimonials__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: parent.querySelector('.testimonials__nav--next'),
        prevEl: parent.querySelector('.testimonials__nav--prev'),
      },
    });
  });
};

export default Testimonials;
